import React from 'react';
import { makeStyles } from '@material-ui/core/styles'
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import DateInput from './Input/Date'
import TextInput from './Input/Text'
import NumberInput from './Input/Number'
import SwitchInput from './Input/Switch'
import SelectInput from './Input/Select'
import moment from 'moment';
import { isEmpty } from 'lodash';
import { useSelector, useDispatch} from 'react-redux'
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(0),
            //   width: '28ch',
        },
    },
}));

export default function InputComponent(props) {
    const classes = useStyles();
    const dispatch = useDispatch()
    const [state, setstate] = React.useState(props.newAvtal.Avtal);
    const [avtalType, setavtalType] = React.useState(0);
    const [disabled, setDisabled] = React.useState(false);
    const TermOfPayment = useSelector(state => state.accountsData.TermOfPayment)
    React.useEffect(()=>{
        onchangeBillingObj("Betalningsvillkor",TermOfPayment)
    },[TermOfPayment])
   const onchangeBillingObj=(Meta,Value)=>{
    if(Meta === "PeriodStart"){
        let periodSlut = 
        moment(Value)
        .add(parseInt(state.BillingIntervall)-1>0 ?parseInt(state.BillingIntervall)-1:0,"month")
        .add(30,"days").format("YYYY-MM-DD")
        setstate({ ...state, [Meta]: Value });
        props.SetAvtalParameters({ ...state,Periodslut:periodSlut, [Meta]:Value })
    }
    else if(Meta === "BillingIntervall"){
        let periodSlut = 
            moment(state.PeriodStart)
            .add(parseInt(Value)-1 >0 ?parseInt(Value)-1:0,"month")
            .format("YYYY-MM-DD")
            setstate({ ...state, [Meta]: Value });
        props.SetAvtalParameters({ ...state,Periodslut:periodSlut, [Meta]:Value })           
    }
    else{
        setstate({ ...state, [Meta]: Value });
        props.SetAvtalParameters({ ...state, [Meta]:Value })
    }
   }
    const handleChange = (event) => {
        setstate({ ...state, "isBilling": (event.target.checked===true)?1:0 });
        props.SetAvtalParameters({ ...state, "isBilling": (event.target.checked===true)?1:0 })
    };
    React.useEffect(()=>{
        if(props.newAvtal.Avtal !== state){
            setstate(props.newAvtal.Avtal)
        }
    },[props.newAvtal.Avtal])
    return (
        <div>
            <form className={classes.root}>
                <div className="d-flex my-2"  style={{ height: 'auto' }}>
                    <div>
                        <p style={{ marginTop: '7px', marginRight: '1rem' }}><IntlMessages id="Contract.Invoicing"/>:</p>
                    </div>
                    <div>
                        <FormGroup row>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={(state.isBilling===1)?true:false}
                                        onChange={handleChange}
                                        name="isBilling"
                                        color="primary"
                                    />
                                }
                            />
                        </FormGroup>
                    </div>
                </div>
                {
                    state.isBilling === 1?
                    <>
                    <div>
                        <div className={`row `} style={{ height: 'auto' }}>
                            <div className="col-12 my-2">
                            <DateInput 
                             Value={state.startDate}
                             Label={<IntlMessages id="input.Date.Start"/>}
                             Meta={"startDate"}
                             onchangeHanelEvent={onchangeBillingObj}
                             />
                            </div>
                            <div className="col-6 my-2">
                            <DateInput
                                Value={state.PeriodStart}
                                Label={<IntlMessages id="input.Date.Period"/>}
                                Meta={"PeriodStart"}
                                onchangeHanelEvent={onchangeBillingObj}
                                /> 
                            </div>
                            <div className="col-6 my-2">
                            <DateInput
                                Value={state.Periodslut}
                                Label={<IntlMessages id="input.Date.Period.end"/>}
                                Meta={"Periodslut"}
                                disAbeld={true}
                                onchangeHanelEvent={onchangeBillingObj}
                                /> 
                            </div>
                            <div className="col-6 my-2">
                            <SwitchInput
                                    Value={parseInt(state.lopande)}
                                    Label={<IntlMessages id="Input.onGoing"/>}
                                    Meta={"lopande"}
                                    onchangeHanelEvent={onchangeBillingObj} 
                                  />
                            </div>
                            <div className="col-6 my-2">
                                {
                                    parseInt(state.lopande)=== 1?
                                    <TextInput
                                    Value={"Månader"}
                                    disAbeld={true}
                                    Label={<IntlMessages id="input.ContractLength"/>}
                                    Meta={"BillingLength"}
                                  />
                                    :
                                    <NumberInput
                                    Value={parseInt(state.BillingLength)}
                                    disAbeld={false}
                                    Label={<IntlMessages id="input.ContractLength"/>}
                                    Meta={"BillingLength"}
                                    onchangeHanelEvent={onchangeBillingObj} 
                                  />
                                }
                            {/*<NumberInput
                                    Value={
                                        parseInt(state.lopande)=== 1?"Månader":
                                        parseInt(state.BillingLength)
                                    }
                                    disAbeld={parseInt(state.lopande)=== 1}
                                    Label={<IntlMessages id="input.ContractLength"/>}
                                    Meta={"BillingLength"}
                                    onchangeHanelEvent={onchangeBillingObj} 
                                  />*/}
                            </div>
                            <div className="col-6 my-2">
                            <NumberInput
                                    Value={
                                      isEmpty(state.BillingIntervall)?1:
                                      parseInt(state.BillingIntervall)
                                    }
                                    Label={<IntlMessages id="input.invoice.Options"/>}
                                    Meta={"BillingIntervall"}
                                    onchangeHanelEvent={onchangeBillingObj} 
                                  />
                                  {/*
                            <SelectInput
                                    Value={
                                      isEmpty(state.BillingIntervall)?1:
                                      parseInt(state.BillingIntervall)
                                    }
                                    Label={<IntlMessages id="input.invoice.Options"/>}
                                    Meta={"BillingIntervall"}
                                    onchangeHanelEvent={onchangeBillingObj} 
                                  />
                                  */}
                            </div>
                            <div className="col-6 my-2">
                            <SelectInput
                                    Value={
                                      isEmpty(state.termofPayment)?TermOfPayment:
                                      parseInt(state.termofPayment)
                                    }
                                    Label={<IntlMessages id="input.Payment.methode"/>}
                                    Meta={"termofPayment"}
                                    onchangeHanelEvent={onchangeBillingObj} 
                                  />
                            </div>
                        </div>
                    </div>
                    </>
                    :""
                }
            </form>
        </div>
    );
}
